// catalogExport.ts — builds a human-readable Markdown catalog document (photos referenced,
// descriptions, provenance-free-text) for insurance/estate purposes. Pure client-side text
// generation — no AI, no network. Delivery reuses cloudStoreSave (brain.ts) + the existing
// desktop save-file-dialog pattern (see App.tsx's doExport / CloudBackup.tsx).
import type { Collection, Item, CollectionSet } from "./store";
import { formatAttr, formatValue } from "./store";
import { fmtDate } from "./App";

export function catalogFilename(collectionName: string): string {
  const slug = collectionName.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "collection";
  const stamp = new Date().toISOString().slice(0, 10);
  return `${slug}-catalog-${stamp}.md`;
}

export function buildCatalogDocument(collection: Collection, items: Item[], sets: CollectionSet[]): string {
  const setName = new Map(sets.map((s) => [s.id, s.name]));
  const have = items.filter((i) => !i.wishlist);
  const lines: string[] = [];
  lines.push(`# ${collection.name}`);
  lines.push("");
  lines.push(`${collection.kind || "Collection"} · ${have.length} item${have.length === 1 ? "" : "s"} · exported ${new Date().toISOString().slice(0, 10)}`);
  lines.push("");
  for (const it of have) {
    lines.push(`## ${it.name}`);
    const meta: string[] = [];
    if (it.acquired_on) meta.push(`Acquired: ${fmtDate(it.acquired_on)}`);
    if (it.source) meta.push(`Source: ${it.source}`);
    if (it.condition) meta.push(`Condition: ${it.condition}`);
    if (it.cost !== null) meta.push(`Value logged: ${formatValue(it.cost)}`);
    if (it.set_id && setName.get(it.set_id)) meta.push(`Set: ${setName.get(it.set_id)}`);
    if (meta.length) lines.push(meta.join(" · "));
    for (const f of collection.attr_schema) {
      const v = formatAttr(it.attrs?.[f.key]);
      if (v) lines.push(`- ${f.label}: ${v}`);
    }
    if (it.notes) { lines.push(""); lines.push(it.notes); }
    lines.push("");
  }
  return lines.join("\n").trim() + "\n";
}
